"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 7: AxROM
 * ------------------------------------------------------------------ */
// AxROM

function register(Mappers) {
  Mappers[7] = function (nes) {
    this.nes = nes;
  };

  Mappers[7].prototype = new Mappers[0]();

  Mappers[7].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // 3 bits of 32 KB PRG, 2 bits of 8 KB CHR, 1 bit of single screen mirroring.
    this.load32kRomBank(value & 0x07, 0x8000);
    this.load8kVromBank(((value >> 3) & 0x03) * 2, 0x0000);
    this.setMirroring(
      (value & 0x10) !== 0
        ? this.nes.rom.SINGLESCREEN_MIRRORING2
        : this.nes.rom.SINGLESCREEN_MIRRORING,
    );
  };

  Mappers[7].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("AxROM: Invalid ROM! Unable to load.");
    }

    this.reset();
    // AxROM powers on with the last 32 KB bank mapped in.
    this.load32kRomBank(this.nes.rom.romCount / 2 - 1, 0x8000);
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };
}

module.exports = { register: register };
